import { listFiles, searchFiles, getFileDescriptor } from '@wix/ambassador-media-site-media-v1-file-descriptor/http';
import { SortOrder } from '@wix/ambassador-media-site-media-v1-file-descriptor/types';
import { listFolders } from '@wix/ambassador-media-site-media-v1-folder/http';
import { MediaManagerApiBase } from '../MediaManagerApiBase';
import { getMediaTypesFromString } from './requestMappers/MediaType.mappers';
import { mapFile, mapFiles } from './responseMappers/File.mappers';
import { mapFolders } from './responseMappers/Folder.mappers';
const displayNameField = 'displayName';
const updatedDateField = 'updatedDate';
export class PlatformizedApi extends MediaManagerApiBase {
  constructor(settings) {
    super();
    this.settings = settings;
  }
  async listItems(folderId, params) {
    var _data$nextCursor;
    const {
      httpClient,
      source,
      rawNamespace
    } = this.settings;
    const {
      mediaType,
      paging,
      sort
    } = params;
    const mediaTypes = mediaType ? getMediaTypesFromString(mediaType) : [];
    const request = {
      parentFolderId: folderId,
      mediaTypes,
      private: Boolean(this.settings.rawNamespace),
      // private files should always be with some namespace
      paging: {
        limit: paging.size,
        cursor: paging.cursor
      },
      sort: {
        fieldName: sort.order === 'name' ? displayNameField : updatedDateField,
        order: sort.direction === 'asc' ? SortOrder.ASC : SortOrder.DESC
      },
      rawNamespace
    };
    const {
      data
    } = await httpClient.request(listFiles(request));
    const {
      files = []
    } = data;
    const mappedFiles = mapFiles(files, {
      source
    }, this.settings.onError);
    const cursor = ((_data$nextCursor = data.nextCursor) == null || (_data$nextCursor = _data$nextCursor.cursors) == null ? void 0 : _data$nextCursor.next) || null;
    return {
      data: mappedFiles,
      paging: {
        cursor
      }
    };
  }
  async listFolders(folderId, params) {
    var _data$nextCursor2;
    const {
      httpClient,
      source,
      rawNamespace
    } = this.settings;
    const paging = (params == null ? void 0 : params.paging) ?? {
      size: 50,
      cursor: null
    };
    const sort = (params == null ? void 0 : params.sort) ?? {
      order: 'date',
      direction: 'desc'
    };
    const request = {
      parentFolderId: folderId,
      rawNamespace,
      paging: {
        limit: paging.size,
        cursor: paging.cursor ?? undefined
      },
      sort: {
        fieldName: sort.order === 'name' ? 'displayName' : 'updatedDate',
        order: sort.direction === 'asc' ? SortOrder.ASC : SortOrder.DESC
      }
    };
    const {
      data
    } = await httpClient.request(listFolders(request));
    const folders = data.folders ?? [];
    const mappedFolders = mapFolders(folders, source);
    const cursor = ((_data$nextCursor2 = data.nextCursor) == null || (_data$nextCursor2 = _data$nextCursor2.cursors) == null ? void 0 : _data$nextCursor2.next) ?? null;
    return {
      data: mappedFolders,
      paging: {
        cursor
      }
    };
  }
  async privateItemInfo(fileId) {
    const {
      httpClient,
      source
    } = this.settings;
    const {
      data
    } = await httpClient.request(getFileDescriptor({
      fileId
    }));
    const file = data == null ? void 0 : data.file;
    if (!file) {
      throw new Error(`[PlatformizedApi] File not found: ${fileId}`);
    }
    const mappedFile = mapFile(file, {
      source
    });
    return {
      data: mappedFile
    };
  }
  async searchItems(_folderId, searchQuery, params) {
    var _data$nextCursor3;
    const {
      httpClient,
      source,
      rawNamespace
    } = this.settings;
    const {
      mediaType,
      paging,
      sort
    } = params;
    const mediaTypes = mediaType ? getMediaTypesFromString(mediaType) : [];
    const request = {
      search: searchQuery,
      mediaTypes,
      private: Boolean(this.settings.rawNamespace),
      paging: {
        limit: paging.size,
        cursor: paging.cursor
      },
      sort: {
        fieldName: sort.order === 'name' ? displayNameField : updatedDateField,
        order: sort.direction === 'asc' ? SortOrder.ASC : SortOrder.DESC
      },
      rawNamespace
    };
    const {
      data
    } = await httpClient.request(searchFiles(request));
    const {
      files = []
    } = data;
    const mappedFiles = mapFiles(files, {
      source
    }, this.settings.onError);
    const cursor = ((_data$nextCursor3 = data.nextCursor) == null || (_data$nextCursor3 = _data$nextCursor3.cursors) == null ? void 0 : _data$nextCursor3.next) || null;
    return {
      data: mappedFiles,
      paging: {
        cursor
      }
    };
  }
}
//# sourceMappingURL=PlatformizedApi.js.map